export default __webpack_public_path__ + "static/media/@amandakislley.896707a8.jpg";